/**
 * Site themes
 */
export const themes = [
  {
    siteBrandName: 'targetjobs',
    id: 'default',
    variables: {
        'ids-color-foreground': '23 25 28',
        'ids-color-background': '255 255 255',
        'ids-color-primary': '78 33 255',
        'ids-color-primary-50': '246 243 255',
        'ids-color-primary-200': '219 210 255',
        'ids-color-primary-400': '184 166 255',
        'ids-color-primary-700': '130 99 255',
        'ids-color-primary-1100': '55 22 190',
        'ids-color-primary-foreground': '255 255 255',
        'ids-color-secondary': '255 35 114',
        'ids-color-secondary-50': '255 244 248',
        'ids-color-secondary-200': '255 211 227',
        'ids-color-secondary-400': '255 167 199',
        'ids-color-secondary-700': '255 101 157',
        'ids-color-secondary-1100': '193 6 73',
        'ids-color-secondary-foreground': '255 255 255',
        'ids-color-tertiary': '211 255 33',
        'ids-color-tertiary-50': '253 255 244',
        'ids-color-tertiary-200': '246 255 211',
        'ids-color-tertiary-400': '237 255 166',
        'ids-color-tertiary-700': '224 255 100',
        'ids-color-tertiary-1100': '182 215 56',
        'ids-color-tertiary-foreground': '3 3 3',
        'site-logo-color': '#FF2372',
        'chilli-color-primary': 'var(--ids-color-primary)',
        'chilli-color-primary-50': 'var(--ids-color-primary-50)',
        'chilli-color-primary-200': 'var(--ids-color-primary-200)',
        'chilli-color-primary-400': 'var(--ids-color-primary-400)',
        'chilli-color-primary-700': 'var(--ids-color-primary-700)',
        'chilli-color-primary-1100': 'var(--ids-color-primary-1100)',
        'chilli-contrast-primary': '255 255 255',
        'chilli-color-secondary': 'var(--ids-color-secondary)',
        'chilli-color-secondary-50': 'var(--ids-color-secondary-50)',
        'chilli-color-secondary-200': 'var(--ids-color-secondary-200)',
        'chilli-color-secondary-400': 'var(--ids-color-secondary-400)',
        'chilli-color-secondary-700': 'var(--ids-color-secondary-700)',
        'chilli-color-secondary-1100': 'var(--ids-color-secondary-1100)',
        'chilli-contrast-secondary': '255 255 255',
        'chilli-color-tertiary': 'var(--ids-color-tertiary)',
        'chilli-color-tertiary-50': 'var(--ids-color-tertiary-50)',
        'chilli-color-tertiary-200': 'var(--ids-color-tertiary-200)',
        'chilli-color-tertiary-400': 'var(--ids-color-tertiary-400)',
        'chilli-color-tertiary-700': 'var(--ids-color-tertiary-700)',
        'chilli-color-tertiary-1100': 'var(--ids-color-tertiary-1100)',
        'chilli-contrast-tertiary': '3 3 3'
    }
  },
  {
    siteBrandName: 'gradireland',
    id: 'default',
    variables: {
        'ids-color-foreground': '23 25 28',
        'ids-color-background': '255 255 255',
        'ids-color-primary': '78 33 255',
        'ids-color-primary-50': '246 243 255',
        'ids-color-primary-200': '219 210 255',
        'ids-color-primary-400': '184 166 255',
        'ids-color-primary-700': '130 99 255',
        'ids-color-primary-1100': '55 22 190',
        'ids-color-primary-foreground': '255 255 255',
        'ids-color-secondary': '64 154 255',
        'ids-color-secondary-50': '245 250 255',
        'ids-color-secondary-200': '217 235 255',
        'ids-color-secondary-400': '179 215 255',
        'ids-color-secondary-700': '121 184 255',
        'ids-color-secondary-1100': '7 69 148',
        'ids-color-secondary-foreground': '255 255 255',
        'ids-color-tertiary': '255 74 194',
        'ids-color-tertiary-50': '255 246 252',
        'ids-color-tertiary-200': '255 219 243',
        'ids-color-tertiary-400': '255 183 230',
        'ids-color-tertiary-700': '255 129 212',
        'ids-color-tertiary-1100': '203 40 137',
        'ids-color-tertiary-foreground': '3 3 3',
        'site-logo-color': '#008BC0',
        'chilli-color-primary': 'var(--ids-color-primary)',
        'chilli-color-primary-50': 'var(--ids-color-primary-50)',
        'chilli-color-primary-200': 'var(--ids-color-primary-200)',
        'chilli-color-primary-400': 'var(--ids-color-primary-400)',
        'chilli-color-primary-700': 'var(--ids-color-primary-700)',
        'chilli-color-primary-1100': 'var(--ids-color-primary-1100)',
        'chilli-contrast-primary': '255 255 255',
        'chilli-color-secondary': 'var(--ids-color-secondary)',
        'chilli-color-secondary-50': 'var(--ids-color-secondary-50)',
        'chilli-color-secondary-200': 'var(--ids-color-secondary-200)',
        'chilli-color-secondary-400': 'var(--ids-color-secondary-400)',
        'chilli-color-secondary-700': 'var(--ids-color-secondary-700)',
        'chilli-color-secondary-1100': 'var(--ids-color-secondary-1100)',
        'chilli-contrast-secondary': '255 255 255',
        'chilli-color-tertiary': 'var(--ids-color-tertiary)',
        'chilli-color-tertiary-50': 'var(--ids-color-tertiary-50)',
        'chilli-color-tertiary-200': 'var(--ids-color-tertiary-200)',
        'chilli-color-tertiary-400': 'var(--ids-color-tertiary-400)',
        'chilli-color-tertiary-700': 'var(--ids-color-tertiary-700)',
        'chilli-color-tertiary-1100': 'var(--ids-color-tertiary-1100)',
        'chilli-contrast-tertiary': '3 3 3'
    }
  }  
]

/**
 * Converts an array of variables to a string
 * @param theme {Theme}
 * @returns {string}
 */
export const generateCssVariables = (theme) => {
    let variables = '';
    for (const [key, value] of Object.entries(theme?.variables)) {
        variables = `${variables}--${key}:${value};`
    };
    return variables;
}